export class ImportConstants {

    public static AUFNAHME_BERATER = 'Berater';
    public static AUFNAHME_BWL = 'Betriebswirtschaft etc.';
    public static AUFNAHME_KRAFTSTOFFE = 'Kraftstoffe';
    public static AUFNAHME_STROM = 'Strom';
    public static AUFNAHME_WAERME = 'Wärme';
    public static AUFNAHME_WASSER = 'Wasser';
    public static COL_AUFNAHME_BEMERKUNG = 36;
    public static COL_AUFNAHME_BEMERKUNG_BERATER = 34;
    public static COL_AUFNAHME_EINHEIT = 34;
    public static COL_AUFNAHME_TITEL = 2;
    public static SHEET_AUFNAHME = 'Aufnahmebogen';
    public static SHEET_IMPRESSUM = 'Impressum';
}
